module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "passwordCheck"
  }, [_c('mu-flexbox', {
    attrs: {
      "align": "baseline"
    }
  }, [_c('mu-flexbox-item', [(_vm.isPasswordLengthValid !== false) ? _c('div', {
    staticClass: "pw-rules"
  }, [(_vm.isPasswordLengthValid === true) ? _c('img', {
    attrs: {
      "src": require("../../../static/pw/tick_active"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPasswordLengthValid === 'error') ? _c('img', {
    attrs: {
      "src": require("../../../static/pw/tick_error"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    class: {
      active: _vm.isPasswordLengthValid === true,
      error: _vm.isPasswordLengthValid === 'error'
    }
  }, [_vm._v("Password must not be more than "), _c('strong', [_vm._v(" " + _vm._s(_vm.maxCharacter) + " characters")])])]) : _vm._e()])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-df8bde1e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PasswordLimitValidation/PasswordLimitValidation.vue
// module id = 3299
// module chunks = 1